import { Controller } from '@hotwired/stimulus'

// This is a Stimulus controller responsible for adding a loader when submitting a form with file uploads
// It is useful with heavy files that may take a while to upload
// It will add a loader after the submit button, be sure to wrap the submit button with a div with d-flex class
// for example:
// <div class="d-flex">
//   <button type="submit" class="btn btn-primary">Submit</button>
// </div>
// /!\ Be careful of css applied to the submit button that may break the loader (margin, padding, width etc.)
export default class FormLoaderController extends Controller {
  connect() {
    Rails.delegate(this.element, Rails.formInputClickSelector, 'click', (event) => {
      if (this.element.checkValidity()) {
        const button = event.target
        button.insertAdjacentHTML('afterend', '<div class="form-loader"></div>');
      }
    })

    // Not necessarly needed if form content is overrided
    Rails.delegate(this.element, 'form', 'ajax:complete', () => {
      const loader = this.element.querySelector('.form-loader');

      loader.remove();
    })
  }
}
